<template>
    <div class="studentList">
        <a-table :dataSource="dataSource" :columns="columns" />
    </div>
</template>
<script>
export default {
    name: 'studentList',
    components: {},
    data() {
        return {
            dataSource: [],
            columns: [
                {
                    title: '序号',
                    dataIndex: 'name',
                    key: 'name',
                }, {
                    title: '账号',
                    dataIndex: 'name',
                    key: 'name',
                }, {
                    title: '性别',
                    dataIndex: 'name',
                    key: 'name',
                }, {
                    title: '学校',
                    dataIndex: 'name',
                    key: 'name',
                }, {
                    title: '年级',
                    dataIndex: 'name',
                    key: 'name',
                }, {
                    title: '联系方式A',
                    dataIndex: 'name',
                    key: 'name',
                }, {
                    title: '联系方式B',
                    dataIndex: 'name',
                    key: 'name',
                }, {
                    title: '入班日期',
                    dataIndex: 'name',
                    key: 'name',
                }, {
                    title: '操作',
                    dataIndex: 'name',
                    key: 'name',
                },
            ],
        }
    },
    created() { },
    mounted() { },
    methods: {}
}
</script>
<style lang='scss' scoped></style>
